import React, { useEffect, useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import SelectOrder from './SelectOrder';
import _ from 'lodash';
import CategoryAndSubcategory from './CategoryAndSubcategory';
import { Input, Typography } from 'antd';
import { useOrderSearchForTicket, useTicketConfig } from './store';
import TicketDescription from './TicketDescription';
import CreateTicketFooter from './CreateTicketFooter';
import secureLocalStorage from 'react-secure-storage';
import { LOCAL_STORAGE_CONFIG } from "config";
const { Search } = Input;
const { Title } = Typography;
const { ID } = LOCAL_STORAGE_CONFIG;

const CreateTicketScreen = ({ customerData }) => {
    const { fetchCustomerDetails, customerDetails } = useOrderSearchForTicket();
    const { fetchTicketConfig } = useTicketConfig();
    const [orders, setOrders] = useState([]);
    const [shipmentAddress, setShipmentAddress] = useState()
    const [selectedOrder, setSelectedOrder] = useState({});
    const [slotBookingPayload, setSlotBookingPayload] = useState({})
    const [validation, setValidation] = useState({})
    const [ticketPayload, setTicketPayload] = useState(
        {
            case_id: null,
            provider: null,
            current_assignment: null,
            author_id: ID,
            action_taker: ID,
            priority: "4",
            category: null,
            sub_category: null,
            is_internal: false,
            products: [],
            total_refund_price: "0.00",
            address: shipmentAddress,
            waba: true,
            remark: "",
            source: "crm",
            source_meta: {},
            provider_meta: { due_date: null },
            comment: {},
            due_date: null,
        }
    )

    useEffect(() => { setTicketPayload(prevPayload => ({ ...prevPayload, case_id: customerData?.id })) }, [customerData])
    const setOrderAndAddress = (orders) => {
        setOrders(orders);
        const customerAddress = _.get(orders, [0, 'order_meta', 'shipping_address'], {});
        setShipmentAddress({
            locality: _.get(customerAddress, 'address1', ''),
            landmark: _.get(customerAddress, 'address2', ''),
            city: _.get(customerAddress, 'city', ''),
            state: _.get(customerAddress, 'province', ''),
            pincode: _.get(customerAddress, 'zip', '')
        })
    }
    useEffect(() => { setOrderAndAddress(_.get(customerData, 'orders', [])); }, [customerData]);
    useEffect(() => { if (_.size(customerDetails) > 0) { setOrderAndAddress(customerDetails); } }, [customerDetails]);
    useEffect(() => { setTicketPayload((prevPayload) => ({ ...prevPayload, address: shipmentAddress })) }, [shipmentAddress]);

    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const handleShow = () => {
        setOpen(true);
        fetchTicketConfig(customerData?.id);
    };
    const idInput = (value) => { if (value) { fetchCustomerDetails(value); } };
    return (
        <>
            <button
                onClick={handleShow}
                className="btn btn-outline-primary  m-2 "
                style={{ padding: "0.5rem", width: "9rem" }}
            >
                Create Ticket
            </button>
            <Offcanvas show={open} onHide={handleClose} placement={'end'}
                style={{ width: "41vw", overflowY: "hidden" }}
            >
                <Offcanvas.Header >
                    <Offcanvas.Title style={{ width: '100%' }}>
                        <div className='d-flex justify-content-between align-items-center' style={{ width: '100%' }}>
                            <Title level={4} className='pb-0 mb-0' style={{ width: '40%' }}>Create Ticket</Title>
                            <Search style={{ width: '60%' }} addonBefore="Search" placeholder="Search orders by order Id/email /phone number" onSearch={idInput} allowClear />
                        </div>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div style={{ height: '92%', overflowY: 'scroll' }} className='scrollable-container'>
                        <SelectOrder orders={orders} setSelectedOrder={setSelectedOrder} setTicketPayload={setTicketPayload} setSlotBookingPayload={setSlotBookingPayload} setValidation={setValidation} />
                        <CategoryAndSubcategory selectedOrder={selectedOrder} shipmentAddress={shipmentAddress} setShipmentAddress={setShipmentAddress} setTicketPayload={setTicketPayload} setSlotBookingPayload={setSlotBookingPayload} setValidation={setValidation} />
                        <TicketDescription setTicketPayload={setTicketPayload} ticketPayload={ticketPayload} setValidation={setValidation} />
                    </div>
                    <CreateTicketFooter ticketPayload={ticketPayload} validation={validation} slotBookingPayload={slotBookingPayload} />
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};
export default CreateTicketScreen;